<template>
	<div style="width: 100%;" class="d-flex">
		<div style="width: 19%;margin-right: 1%;height: 700px;background: #fff;">
			<div class="search-option"><el-tree :data="data" node-key="id" :default-checked-keys="[1,2,3]" show-checkbox default-expand-all :props="defaultProps" class="mt-1"></el-tree></div>
		</div>
		<div style="width: 80%;">
			<div class="d-flex p-2" style="align-items: center;">
				<div style="font-size: 14px;" class="mr-2" v-if="activeIndex == 1">日期筛选</div>
				<div style="font-size: 14px;" class="mr-2" v-else>年份筛选</div>
				<el-date-picker  v-model="value1" type="daterange"
					range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" 
					size="mini" class="mr-2" v-if="activeIndex == 1"></el-date-picker>
				<el-date-picker
				      v-model="value2"
				      type="year"
				      placeholder="选择年份" size="mini" class="mr-2" v-else>
				    </el-date-picker>
				<el-button type="primary" size="mini">查询</el-button>
			</div>
			<div style="width: 100%;background: #fff;">
				<el-menu :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect" size="mini">
					<el-menu-item index="1">日期</el-menu-item>
					<el-menu-item index="2">月度</el-menu-item>
					<el-menu-item index="3">季度</el-menu-item>
				</el-menu>
				<el-table class="mt-3" :data="form" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight" v-if="activeIndex == 1">
					<el-table-column prop="lx" label="类别"></el-table-column>
					<el-table-column prop="je" label="金额"></el-table-column>
				</el-table>
				<el-table class="mt-3" :data="forma" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight" v-else-if="activeIndex == 2">
					<el-table-column prop="lx" label="类别"></el-table-column>
					<el-table-column prop="je" label="1月"></el-table-column>
					<el-table-column prop="je" label="2月"></el-table-column>
					<el-table-column prop="je" label="3月"></el-table-column>
					<el-table-column prop="je" label="4月"></el-table-column>
					<el-table-column prop="je" label="5月"></el-table-column>
					<el-table-column prop="je" label="6月"></el-table-column>
					<el-table-column prop="je" label="7月"></el-table-column>
					<el-table-column prop="je" label="8月"></el-table-column>
					<el-table-column prop="je" label="9月"></el-table-column>
					<el-table-column prop="je" label="10月"></el-table-column>
					<el-table-column prop="je" label="11月"></el-table-column>
					<el-table-column prop="je" label="12月"></el-table-column>
					<el-table-column prop="je" label="合计金额" align="right"></el-table-column>
				</el-table>
				<el-table class="mt-3" :data="formb" style="width: 100%" @selection-change="handleSelectionChange" size="mini" :max-height="maxHeight" v-else>
					<el-table-column prop="lx" label="类别"></el-table-column>
					<el-table-column prop="je" label="第1季度"></el-table-column>
					<el-table-column prop="je" label="第2季度"></el-table-column>
					<el-table-column prop="je" label="第3季度"></el-table-column>
					<el-table-column prop="je" label="第4季度"></el-table-column>
					<el-table-column prop="je" label="合计金额" align="right"></el-table-column>
				</el-table>
			</div>
			<!-- 商品列表 -->
		</div>
	</div>
</template>

<script>
import buttonSearch from '@/components/common/button-search.vue'; // 引入 按钮、搜索、高级搜索组件
import common from '@/common/mixins/common.js'; // 引入 全局共公样式
import { mapState } from 'vuex'; // 引入 全局 公共数据
export default {
	mixins: [common], // 引入mixins里的common.js
	inject: ['layout'], // 依赖注入
	// 引入注册
	components: {
		buttonSearch
	},
	data() {
		return {
			activeIndex: '1',
			form: [
				{
					lx: '销售收入',
					je: 1321454
				},
				{
					lx: '销售成本',
					je: 21454
				},
				{
					lx: '财务成本',
					je: 221454
				},
				{
					lx: '利润',
					je: 321454
				}
			],
			forma: [
				{
					lx: '销售收入',
					je: 1321454
				},
				{
					lx: '销售成本',
					je: 21454
				},
				{
					lx: '财务成本',
					je: 221454
				},
				{
					lx: '利润',
					je: 321454
				}
			],
			formb: [
				{
					lx: '销售收入',
					je: 1321454
				},
				{
					lx: '销售成本',
					je: 21454
				},
				{
					lx: '财务成本',
					je: 221454
				},
				{
					lx: '利润',
					je: 321454
				}
			],
			value1: '',
			value2: '',
			data: [
				{
					id: 1,
					label: '收入记账',
					children: [
						{
							id: 4,
							label: '收款订单'
						},
						{
							id: 5,
							label: '预收款订单'
						},
						{
							id: 6,
							label: '收回欠款'
						},
						{
							id: 7,
							label: '退还收入'
						},
						{
							id: 8,
							label: '借入/收押金等'
						},
						{
							id: 9,
							label: '转账取存'
						}
					]
				},
				{
					id: 2,
					label: '支出记账',
					children: [
						{
							id: 10,
							label: '付款订单'
						},
						{
							id: 11,
							label: '预付款订单'
						},
						{
							id: 12,
							label: '偿还欠款'
						},
						{
							id: 13,
							label: '退还支出'
						},
						{
							id: 14,
							label: '借出/交押金等'
						}
					]
				},
				{
					id: 3,
					label: '产品记账',
					children: [
						{
							id: 15,
							label: '采购出库收入'
						},
						{
							id: 16,
							label: '采购入库支出'
						},
						{
							id: 17,
							label: '库存处理收入'
						},
						{
							id: 18,
							label: '库存处理支出'
						},
						{
							id: 19,
							label: '产品销售收入'
						},
						{
							id: 20,
							label: '产品退货支出'
						}
					]
				}
			],
			defaultProps: {
				children: 'children',
				label: 'label'
			},
			maxHeight:0,
			
		};
	},
	mounted() {
		this.$nextTick(() => {
			this.maxHeight = window.innerHeight - 274; //300是页面中除了表格外其他组件的高度
		});
	},
	methods: {
		handleSelect(key, keyPath) {
			this.activeIndex = key
			console.log(this.activeIndex)
		}
	}
};
</script>

<style scoped>
	.search-option >>>.el-tree-node__label {
	    font-size: 12px;
	}
</style>
